<template>
  <v-card class="mx-auto" max-width="300">
    <v-img
      class="white--text align-end"
      height="200px"
      :src="game.img"
    >
    </v-img>

    <v-card-text class="text--primary">
      <div>{{ game.name }}</div>
      <div class="ma-2">{{ game.shortDesc }}</div>
    </v-card-text>

    <v-card-actions>
      <v-spacer></v-spacer>
      <v-dialog max-width="500px">
        <template v-slot:activator="{ on, attrs }">
          <v-btn color="accent" v-bind="attrs" v-on="on"> Learn More </v-btn>
        </template>
        <Modal v-bind:game="game"></Modal>
      </v-dialog>
    </v-card-actions>
  </v-card>
</template>

<script>
import Modal from "@/components/Modal.vue";
export default {
  components:{
    Modal
  },
  props: {
    game: {
      type: Object,
    },
  },
};
</script>